import { FC } from "react";
import { TCardIntroductionProps } from "./Card.config";
import { TextBody } from "../../typography/TextBody";
import { TextEyebrow } from "../../typography/TextEyebrow";

export const CardIntroduction: FC<TCardIntroductionProps> = ({ eyebrow, title, description }) => (
  <div
    data-component="CardIntroduction"
    className="flex flex-col space-y-2 p-4"
  >
    <TextEyebrow
      child={{
        component: "subtitle",
        size: 3,
        children: title,
      }}
    >{ eyebrow }</TextEyebrow>
    { description ? (
      <TextBody size={2} isResponsive={false}>{ description }</TextBody>
    ): null }
  </div>
);
